import { PulseLoader } from 'react-spinners';
import { Container } from './LoadingLine.styles';

const LoadingLine = () => {
  return (
    <Container>
      <PulseLoader color="#1371fe" />
    </Container>
  );
};

export { LoadingLine };
